import { useEffect } from "react";
import { SEO } from "@/components/SEO";
import { HeroSection } from "@/components/home/HeroSection";
import { MarqueeSection } from "@/components/home/MarqueeSection";
import { StatsSection } from "@/components/home/StatsSection";
import { WarumSection } from "@/components/home/WarumSection";
import { ProjekteSection } from "@/components/home/ProjekteSection";
import { KohlbrennerShowcase } from "@/components/home/KohlbrennerShowcase";
import { LeistungenSection } from "@/components/home/LeistungenSection";
import { FotoMosaik } from "@/components/home/FotoMosaik";
import { ProzessSection } from "@/components/home/ProzessSection";
import { CraftEditorial } from "@/components/home/CraftEditorial";
import { PartnerSection } from "@/components/home/PartnerSection";
import { TestimonialsSection } from "@/components/home/TestimonialsSection";
import { FaqSection } from "@/components/home/FaqSection";
import { MagazinTeaser } from "@/components/home/MagazinTeaser";
import { FinalCtaSection } from "@/components/home/FinalCtaSection";

function useReveal() {
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("visible"); }),
      { threshold: 0.04, rootMargin: "0px 0px -20px 0px" }
    );
    els.forEach((el) => observer.observe(el));
    return () => els.forEach((el) => observer.unobserve(el));
  });
}

export default function Home() {
  useReveal();

  return (
    <div>
      <SEO
        title="Premium-Holzbau Meran – Zimmerei & Holzkonstruktionen Südtirol"
        description="Holzbuddy – Ihre Zimmerei für Premium-Holzbau in Meran und Südtirol. Dachstühle, Aufstockungen, Holzfassaden, Holzhäuser und Hotelbau. Präzise geplant, sauber umgesetzt."
        canonical="/"
      />
      <HeroSection />
      <MarqueeSection />
      <StatsSection />
      <WarumSection />
      <ProjekteSection />
      <KohlbrennerShowcase />
      <LeistungenSection />
      <FotoMosaik />
      <ProzessSection />
      <CraftEditorial />
      <PartnerSection />
      <TestimonialsSection />
      <FaqSection />
      <MagazinTeaser />
      <FinalCtaSection />
    </div>
  );
}
